export default "__VITE_ASSET__CuAEZ34C__"